import { createAction } from '@wix/communities-blog-client-common';

export const BUTTON_CLICKED = 'app/BUTTON_CLICKED';

export const buttonClicked = createAction(BUTTON_CLICKED);
